"use client";
import { lightTheme } from "@/components/Nav/Appprovider";
import { ThemeProvider } from "@mui/material";
import React from "react";

export function ThemeWrapper({ children }) {
	return (
		<ThemeProvider theme={lightTheme}>{children}</ThemeProvider>
	);
}
